/**
 * Copyright 2023-2024 Highway9 Networks Inc.
 */
import { RadioGroup } from "../types/radioGroup";
import { ISite } from "../types/site";
import APIService from "./APIServices";

const siteAPI = new APIService<ISite>("radioSites");
const radioGroupAPI = new APIService<RadioGroup>("radioGroups");

export const siteService = {
  getSites: siteAPI.getAll,
  addSite: siteAPI.create,
  updateSite,
  deleteSite: siteAPI.delete,

  getRadioGroups: radioGroupAPI.getAll,
  addRadioGroup,
  updateRadioGroup,
  deleteRadioGroup: radioGroupAPI.delete,
};

/**
 * UI-only / derived fields that must not be persisted to the API or written
 * back into the raw radioGroup entity store.
 */
export function stripDerivedRadioGroupFields(group: RadioGroup): RadioGroup {
  const next = { ...group };
  delete next.radios;
  delete next.radioCoordinates;
  delete next.radioFloorPlanCoods;
  delete next._plmnList;
  delete next._vendorList;
  delete next.countAPs;
  delete next.connectedAPs;
  delete next.overallStatus;
  return next;
}

function updateSite(site: ISite) {
  // Remove properties that are not available in the API
  const updatedSite = structuredClone(site);
  delete updatedSite.countAPs;
  delete updatedSite.connectedAPs;
  delete updatedSite.children;
  delete updatedSite.overallStatus;

  return siteAPI.update(updatedSite);
}

function addRadioGroup(data: RadioGroup) {
  return radioGroupAPI.create(stripDerivedRadioGroupFields(structuredClone(data)));
}

function updateRadioGroup(data: RadioGroup) {
  return radioGroupAPI.update(stripDerivedRadioGroupFields(structuredClone(data)));
}
